import Axios from "./config";

class Artifacts {
  /**
   *
   * @param {*} id
   */
  deleteArtifact(id) {
    return Axios.delete(`/artifacts/${id}`);
  }

  add(exhibitID, typeID, title, file, videoSrc) {
    if (typeID == 3) {
      const data = {
        title,
        typeID,
        exhibitID,
        videoSrc,
      };

      return Axios.post('/artifacts/video', data);
    }

    let formData = new FormData();

    formData.append("title", title);
    formData.append("file", file);
    formData.append("typeID", typeID);
    formData.append("exhibitID", exhibitID);

    return Axios.post("/artifacts", formData);
  }

  /**
   *
   */
  getTypes() {
    return Axios.get("/artifacts/types");
  }
}

export default new Artifacts();



// WEBPACK FOOTER //
// ./src/api/artifacts.js